<div class="tw:rounded-lg tw:bg-white tw:shadow-lg tw:pb-[2px]">
    @if (invoicingPreviewPatient() && !fixedSaleData) {
        <div class="tw:flex tw:items-center tw:justify-start tw:gap-4 tw:p-4 tw:text-sm tw:font-semibold tw:text-neutral-500">
            <div class="tw:flex tw:h-12 tw:w-12 tw:items-center tw:justify-center tw:rounded-full tw:bg-primary-100">
                <i class="material-icons icon tw:text-primary-500 tw:text-3xl tw:mb-1">person</i>
            </div>
            {{ invoicingPreviewPatient().clientName }}
        </div>
    }
    <div class="tw:p-4">
        @if ((checkoutMode() === CheckoutMode.EDIT_SALE || checkoutMode() === CheckoutMode.INVOICE_REMAINING) && editMode() && invoicingPreviewHistory()?.status !== ISaleStatus.DRAFT) {
            <div class="tw:flex tw:mb-4 tw:items-center tw:justify-start tw:gap-4 tw:py-2 tw:px-4 tw:text-sm tw:bg-primary-100 tw:rounded-lg">
                <app-icon icon="info" class="tw:text-primary-400" />
                <div>
                    {{ 'INVOICE_PREVIEW.editingExistingSale' | translate }} <a (click)="replaceSale()" class="tw:text-primary-500 tw:font-bold tw:!underline tw:cursor-pointer">{{'GENERAL.cancel' | translate}}</a>
                </div>
            </div>
        }

        <div class="tw:font-semibold tw:text-neutral-500">{{ 'INVOICE_PREVIEW.summary' | translate }}</div>


        @if (firstLinkedBooking(); as link) {
            <button
                type="button"
                class="tw:my-4 tw:inline-flex tw:flex-wrap tw:items-baseline tw:gap-x-1 tw:!text-xs tw:leading-none tw:font-normal tw:text-primary-500 hover:tw:underline tw:disabled:tw:cursor-not-allowed tw:disabled:tw:opacity-50 tw:disabled:hover:tw:no-underline tw:bg-transparent tw:border-0 tw:p-0 tw:text-left"
                [disabled]="loadingBookingModal()"
                (click)="openLinkedBooking()"
            >
                {{ 'INVOICE_PREVIEW.bookingDate' | translate }}
                <span>{{ link.bookingDateInit | date: 'dd/MM/yyyy' }}</span>
                <span>{{ link.bookingDateInit | date: 'HH:mm' }}</span>
            </button>
        }
    </div>

    @if ((invoicingPreviewCart()?.saleLines ?? []).length > 0) {
        <div class=" ">
            @for (item of invoicingPreviewCart()?.saleLines; let i = $index; track i) {
                <div class="tw:flex tw:items-center tw:justify-between tw:px-4 tw:py-2 tw:shadow-menu tw:text-sm">
                    <div>
                        <div class="tw:flex tw:gap-4 tw:items-center">
                            <div class="tw:flex tw:h-6 tw:w-6 tw:items-center tw:justify-center tw:rounded-full tw:bg-primary-50 tw:font-semibold">
                                {{ item.quantity }}
                            </div>
                            <div class="">{{ item.itemName }}</div>
                        </div>
                        @if (item.providers?.length) {
                            <div class="tw:text-neutral-500 tw:mt-1 tw:pl-10 tw:text-xs">
                                @for (provider of item.providers; let j = $index; track j) {
                                    {{ provider.providerName }}
                                    @if (j < item.providers!.length - 1) {
                                        ,
                                    }
                                }
                            </div>
                        }
                    </div>
                    <div
                        class="tw:flex tw:items-center tw:gap-4"
                        [class.tw:opacity-50]="item.readonly"
                        [class.tw:pointer-events-none]="item.readonly"
                    >
                        <div class="tw:text-sm tw:text-neutral-500">
                            <span class="tw:text-neutral-400">
                                @if (item.discountAmountCents) {
                                    (-{{ (item.discountAmountCents * item.quantity) / 100 | merchantCurrency }})
                                } @else if (item.discountPercentage) {
                                    (-{{ item.discountPercentage | number: '1.0-2' }}%)
                                }
                            </span>
                            @if (item.discountAmountCents || item.discountPercentage) {
                                <span class="tw:line-through tw:mr-2 tw:text-neutral-400">
                                    {{ (item.unitPriceCents * item.quantity) / 100 | merchantCurrency }}
                                </span>

                                @if (item.discountAmountCents) {
                                    {{ (item.unitPriceCents * item.quantity - item.discountAmountCents) / 100 | merchantCurrency }}
                                } @else if (item.discountPercentage) {
                                    {{ (item.unitPriceCents * item.quantity * (1 - item.discountPercentage / 100)) / 100 | merchantCurrency }}
                                }
                            } @else {
                                {{ (item.unitPriceCents * item.quantity) / 100 | merchantCurrency }}
                            }
                        </div>
                        @if (editMode()) {
                            <button class="btn px-0" (click)="editItemInCart(item)">
                                <i class="material-icons icon tw:text-primary-400">edit</i>
                            </button>
                            <button class="btn px-0" (click)="removeItemFromCart(item.cartId)">
                                <i class="material-icons icon tw:text-primary-400">delete</i>
                            </button>
                        }
                    </div>
                </div>
            }
        </div>

        @if (invoicingPreviewTotals().discountAmountCents || invoicingPreviewTotals().discountPercentage) {
            <div class="tw:px-4 tw:py-2 tw:shadow-menu" [class.tw:!animate-pulse]="loadingTotals()" [class.tw:blur-xs]="loadingTotals()">
                <div class="tw:flex tw:justify-between tw:items-center tw:text-sm">
                    <div>{{ 'INVOICE_PREVIEW.discount' | translate }}</div>
                    <div class="tw:flex tw:items-center tw:gap-4">
                        <div [class.blur-sm]="loadingTotals()">
                            <span class="tw:text-neutral-500">(-{{ invoicingPreviewTotals()?.discountPercentage || 0 | number: '1.0-2' }}%)</span>
                            -{{ invoicingPreviewTotals()?.discountAmountCents / 100 || 0 | merchantCurrency }}
                        </div>
                        @if (editMode()) {
                            <button class="btn px-0" (click)="openDiscountModal()">
                                <i class="material-icons icon tw:text-primary-400">edit</i>
                            </button>
                            <button class="btn px-0" (click)="removeGlobalDiscount()">
                                <i class="material-icons icon tw:text-primary-400">delete</i>
                            </button>
                        }
                    </div>
                </div>
            </div>
        }

        <div class="tw:px-4 tw:py-2 tw:shadow-menu" [class.tw:!animate-pulse]="loadingTotals()" [class.tw:blur-xs]="loadingTotals()">
            <div class="tw:flex tw:justify-between tw:text-sm">
                <div>{{ 'INVOICE_PREVIEW.subTotal' | translate }}</div>
                <div [class.blur-sm]="loadingTotals()">{{ invoicingPreviewTotals()?.subtotalCents / 100 || 0 | merchantCurrency }}</div>
            </div>
        </div>

        <div class="tw:px-4 tw:py-2 tw:shadow-menu" [class.tw:!animate-pulse]="loadingTotals()" [class.tw:blur-xs]="loadingTotals()">
            <div class="tw:flex tw:justify-between tw:text-sm">
                <div>{{ 'INVOICE_PREVIEW.totalVAT' | translate }}</div>
                <div [class.blur-sm]="loadingTotals()">{{ invoicingPreviewTotals()?.vatCents / 100 || 0 | merchantCurrency }}</div>
            </div>
        </div>

        <div class="tw:px-4 tw:py-2 tw:shadow-menu" [class.tw:!animate-pulse]="loadingTotals()" [class.tw:blur-xs]="loadingTotals()">
            <div class="tw:flex tw:justify-between tw:font-semibold">
                <div>{{ 'GENERAL.total' | translate }}</div>
                <div [class.blur-sm]="loadingTotals()">{{ invoicingPreviewTotals()?.totalCents / 100 || 0 | merchantCurrency }}</div>
            </div>
        </div>

        @if (editMode() && allItemsHaveZeroUnitPrice()) {
            <p class="tw:px-4 tw:py-2 tw:text-sm tw:text-error-500">
                {{ 'INVOICE_PREVIEW.atLeastOneItemMustHavePrice' | translate }}
            </p>
        }

        @if (invoicingPreviewCart()?.description) {
            <div class="tw:px-4 tw:py-4 tw:text-sm tw:text-neutral-500">
                {{ invoicingPreviewCart()?.description }}
            </div>
        }

        <!-- PAYMENT HISTORY SECTION -->
        @let history = invoicingPreviewHistory();
        @if (history && ((history?.totalCents ?? 0) > 0 || (history?.salePayments?.length ?? 0) > 0 || (history?.creditNotes?.length ?? 0) > 0)) {
            <div class="tw:m-1 tw:rounded-lg tw:bg-primary-50 tw:p-4">
                <div class="tw:border-b tw:border-b-neutral-200 tw:font-semibold tw:text-neutral-500">
                    {{ 'SALE_DETAILS.history' | translate }}
                </div>

                <app-payment-history-summary [paymentHistory]="history" />

                @if (showSendPaymentLinkButton && history?.status === ISaleStatus.PENDING_PAYMENT && hasValidPaymentReference()) {
                    <button class="btn btn-sm btn-primary tw:w-full tw:mt-2" (click)="sendPaymentLink()">
                        {{ 'INVOICE_PREVIEW.sendPaymentLink' | translate }}
                    </button>
                }
                @if (showEditPaymentButton && history?.salePayments?.length > 0 && !onlyHasOnlinePayments()) {
                    <button class="btn btn-sm btn-secondary tw:w-full tw:mt-2" (click)="editPayments()">
                        {{ 'INVOICE_PREVIEW.editPayments' | translate }}
                    </button>
                }
            </div>
        }
        <!-- DISCOUNT CTA -->
        @if (
            checkoutMode() === CheckoutMode.CREATE_FULL_SALE &&
            !invoicingPreviewTotals().discountAmountCents &&
            !invoicingPreviewTotals().discountPercentage &&
            editMode()
        ) {
            <div class="tw:flex tw:justify-center tw:px-4 tw:py-2">
                <button class="btn btn-sm !p-0" (click)="openDiscountModal()">
                    <i class="material-icons icon tw:text-primary-400 tw:mr-2">add_circle</i>
                    {{ 'INVOICE_PREVIEW.discount' | translate }}
                </button>
            </div>
        }
    } @else {
        @if (checkoutMode() === CheckoutMode.ADD_PAYMENT || checkoutMode() === CheckoutMode.EDIT_SALE || checkoutMode() === CheckoutMode.INVOICE_REMAINING) {
            <div class="tw:pb-6">
                <app-loader />
            </div>
        } @else {
            <div class="tw:pb-16 tw:pt-4 tw:text-center tw:text-neutral-400">
                {{ 'INVOICE_PREVIEW.emptyState' | translate }}
            </div>
        }
    }
</div>
